<template>
  <section>
    <div class="container-wrap py-12">
      <div class="pb-4">
        <h2 class="text-h1 mb-2">{{ contextData.name }}</h2>
        <p class="mb-6 text-gray-600">
          {{ contextData.description }}
        </p>
      </div>
      <AreaHelpContactUsFaqCard
        v-for="item in contextData.subSections"
        :key="hash(item)"
        :section-data="item"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import EN_AMERICAS_JSON from '@/assets/data/contact-us-faq/en-americas.json';
  import EN_ASIA_PACIFIC_JSON from '@/assets/data/contact-us-faq/en-asia-pacific.json';
  import EN_EMEA_JSON from '@/assets/data/contact-us-faq/en-emea.json';
  import EN_INT_JSON from '@/assets/data/contact-us-faq/en-int.json';
  import EN_JP_JSON from '@/assets/data/contact-us-faq/en-jp.json';
  import EN_KR_JSON from '@/assets/data/contact-us-faq/en-kr.json';
  import EN_TW_JSON from '@/assets/data/contact-us-faq/en-tw.json';
  import JA_JP_JSON from '@/assets/data/contact-us-faq/ja-jp.json';
  import ZH_CN_JSON from '@/assets/data/contact-us-faq/zh-cn.json';
  import ZH_TW_JSON from '@/assets/data/contact-us-faq/zh-tw.json';
  import type { ISection } from '@/assets/types/api/Pages';

  const { locale } = useI18n();

  const contextData = computed((): ISection => {
    switch (locale.value) {
      case 'en-int':
        return EN_INT_JSON;
      case 'en-americas':
        return EN_AMERICAS_JSON;
      case 'en-jp':
        return EN_JP_JSON;
      case 'en-tw':
        return EN_TW_JSON;
      case 'en-kr':
        return EN_KR_JSON;
      case 'en-asia-pacific':
        return EN_ASIA_PACIFIC_JSON;
      case 'en-emea':
        return EN_EMEA_JSON;
      case 'zh-tw':
        return ZH_TW_JSON;
      case 'zh-cn':
        return ZH_CN_JSON;
      case 'ja-jp':
        return JA_JP_JSON;
      default:
        return EN_INT_JSON;
    }
  });
</script>
